module.exports = __webpack_public_path__ + "static/media/ios-bonfire.edb56a18.svg";